import { IBaseTheme, IThemeSettings } from "../../settings/themes";
export const RELOAD_THEMES = 'RELOAD_THEMES';

// --- DATA MODEL --- //

export interface ThemeSettings
{
    [name: string]: IThemeSettings
}

export interface ThemesState
{
    [name: string]: IBaseTheme
}

// --- ACTION MODEL --- //

interface ReloadThemesAction
{
    type: typeof RELOAD_THEMES;
    themes: ThemeSettings;
}

export type ThemesAction = ReloadThemesAction;

// ------------------- //